<div class="row col-12 col-sm-12 my-account-container">
  <div class="col-3 col-sm-3 d-one d-sm-none my-account-left-nav">
    <app-my-account-left-sidenav [navState]="'MyProfileNavNode'"></app-my-account-left-sidenav>
  </div>

  <div class="submit-warranty-claim col-12 col-sm-12 col-md-12 col-lg-9 my-account-right-nav">
    <ng-container>
      @if (submittedSuccessFully?.claimNumber) {
        <div class="warranty-header-success-msg">
          <div class="content">
            <cx-page-slot position="ConfirmationContentSlot"></cx-page-slot>
          </div>
        </div>
      }
      @if (isFormContainsError) {
        <div class="warranty-header-alert-msg " style="display: block;">
          <div class="content">
            <p>{{ 'common.form_global_error' | cxTranslate }}</p>
          </div>
        </div>
      }
      @if (isFormFilledSuccessfully && !isFormContainsError) {
        <div
          class="warranty-header-warning-msg warning-alert-msg" style="display: block;">
          <div class="content">
            <p>{{ 'common.text_submit_review_carefully' | cxTranslate }}</p>
          </div>
        </div>
      }
    </ng-container>
    <div class="my-section-box">
      <form id="warrantyRequestForm" class="warrantyRequestForm" [formGroup]="warrantyClaimApplication">
        @if (warrantyData$ | async; as warrantyData) {
          <div class="warranty-claim-application-block">
            <h1 class="warranty-claim-headling m-0">{{ 'common.text_return_request_heading' | cxTranslate }}
            </h1>
            <div class="warranty-claim-application-detail">
              <div class="content">
                <cx-page-slot position="TopContent"></cx-page-slot>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                  <label class="control-label kbclass" for="date"
                    [ngStyle]="{'font-size':'24px','font-weight':'bold'}">
                    {{ 'common.text_warranty_submit_customer_information' | cxTranslate }}
                  </label>
                  <div class="select warranty-customID-block na-ref-cust-info-box"
                    (click)="$event.stopPropagation()" (keyup.enter)="$event.stopPropagation()">
                    <div class="fs-wrap">
                      <div class="fs-label-wrap">
                        <div class="col-xs-12 col-sm-12 col-md-12 fs-label"
                          (click)="showSearchResults($event)">
                          @if (!selectedCustomerId) {
                            <span class="customer-id-row">
                              {{ 'common.please_select_your_customer_id' | cxTranslate }}
                            </span>
                          }
                          @if (selectedCustomerId) {
                            <span class="customer-id-section">
                              {{ selectedCustomerId?.salesArea1 }}&nbsp;|&nbsp;
                              {{ selectedCustomerId?.salesArea2 | cxTranslate }}&nbsp;|&nbsp;
                              {{ selectedCustomerId?.salesArea3 }}
                            </span>
                          }
                          <input type="hidden" formControlName="soldTo" readonly>
                        </div>
                      </div>
                      @if (showCustomerList) {
                        <app-customer-id-drop-down
                          [customerId]="warrantyData.b2bUnitsWSList" [pageSource]="'warrantyClaim'"
                          (childValue)="selectedCustomerUnit($event)">
                        </app-customer-id-drop-down>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-xs-12 col-sm-6">
                  <div class="form-group">
                    <label class="control-label kbclass" for="date">
                      {{ 'common.text_warranty_submit_date' | cxTranslate }}
                    </label>
                    <input formControlName="date" class="form-control" type="text" readOnly />
                  </div>
                </div>
                @if (submittedSuccessFully?.warrantyPdf) {
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label class="control-label kbclass" for="returnRequestNumber">
                        {{ 'common.text_warranty_submit_kb_return_request_number' | cxTranslate }}
                      </label>
                      <input formControlName="returnRequestNumber" readonly
                        class="form-control claim-number-check" type="text" readOnly />
                      </div>
                    </div>
                  }
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label class="control-label kbclass" for="claimSubmitDate">
                        {{ 'common.text_warranty_submit_email' | cxTranslate }}
                      </label>
                      <input formControlName="email" class="form-control" type="text" readOnly />
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label class="control-label kbclass" for="phoneNumber">
                        {{ 'common.type_WarrantyClaim_phoneNumber_name' | cxTranslate }}
                      </label>
                      <input formControlName="phoneNumber" class="form-control claim-number-check"
                        type="text" />
                      </div>
                    </div>
                  </div>
                  <!--   <div class="row">
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label class="control-label kbclass" for="email1">
                        {{ 'common.text_warranty_submit_email1' | cxTranslate }}
                      </label>
                      <input formControlName="email1" class="form-control" type="text" />
                    </div>
                  </div>
                  <div class="col-xs-12 col-sm-6">
                    <div class="form-group">
                      <label class="control-label kbclass" for="email2">
                        {{ 'common.text_warranty_submit_email2' | cxTranslate }}
                      </label>
                      <input formControlName="email2" class="form-control claim-number-check"
                        type="text" />
                      </div>
                    </div>
                  </div> -->
                  <div class="row">
                    <div class="col-xs-12 col-sm-6">
                      <div class="form-group">
                        <label class="control-label kbclass" for="PONumber">
                          {{ 'common.text_return_request_po_number' | cxTranslate }}
                        </label>
                        <input formControlName="PONumber" class="form-control" type="text" />
                        <app-error-message [control]="warrantyClaimForm.PONumber"></app-error-message>
                      </div>
                    </div>
                  </div>
                </div>
                <ng-container formArrayName="partInfoDataList">
                  @for (partInfoControls of partInfoDataList.controls; track partInfoControls; let i = $index) {
                    <ng-container [formGroupName]="i">
                      <mat-accordion [multi]="false">
                        <mat-expansion-panel [expanded]="true">
                          <mat-expansion-panel-header class="warranty-part-info-head">
                            <mat-panel-title>
                              {{ 'common.text_warranty_submit_part_information' | cxTranslate }}
                              &nbsp;
                              <span class="heading-part-no">{{ '00' + (i + 1) }}</span>
                              @if (i > 0) {
                                <img src="/images/close-white.svg"
                                  class="removePartNoInfo" (click)="removePartInfo(i)"
                                  alt="Close Icon">
                              }
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <div class="warranty-part-info-block">
                            <div class="row">
                              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                <div class="form-group">
                                  <label class="control-label kbclass" for="partNumber">
                                    {{ 'common.text_return_request_submit_returning_part_number'
                                    |cxTranslate }}
                                  </label>
                                  <input formControlName="partNumber"
                                    (blur)="isEligibleForReturn($event, i)"
                                    class="form-control custom-part-number-input" type="text">
                                    @if (productNotFound[i]) {
                                      <div class="text-danger">
                                      {{productNotFound[i]}}</div>
                                    }
                                    <app-error-message
                                    [control]="getPartInfoControl(i,'partNumber')"></app-error-message>
                                  </div>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6">
                                  <div class="form-group">
                                    <label class="control-label  kbclass" for="quantity">
                                      {{ 'common.text_warranty_submit_part_quantity' | cxTranslate
                                      }}
                                    </label>
                                    <input formControlName="quantity"
                                      class="form-control kb-part-number-input" type="number">
                                      <app-error-message
                                      [control]="getPartInfoControl(i,'quantity')"></app-error-message>
                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-xs-12 col-sm-12 col-md-6 form-group">
                                    <label class="control-label  kbclass"
                                    for="returnRequestType">{{'common.text_return_request_return_type'|cxTranslate}}</label>
                                    <div class="form-group return-request-select-box mb-0">
                                      <select formControlName="returnRequestType"
                                        class="form-control">
                                        <option value="null" disabled
                                          [selected]="getPartInfoControl(i,'returnRequestType').value == null">
                                          {{'common.form_select_empty_axle_position'|cxTranslate}}
                                        </option>
                                        @for (item of warrantyData.returnTypes; track item) {
                                          <option [value]="item.code"
                                            >
                                            {{item.name}}
                                          </option>
                                        }
                                      </select>
                                    </div>
                                    <app-error-message
                                    [control]="getPartInfoControl(i,'returnRequestType')"></app-error-message>
                                  </div>
                                </div>
                                <!-- ATTACHMENTS SECTION -->
                                <div class="col-xs-12 col-sm-12 px-0 view-button-block">
                                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 view-button-column">
                                    <div class="form-group">
                                      <label class="control-label kbclass">
                                        {{ 'common.text_retrun_request_submit_part_nature_defect'
                                        |cxTranslate }}
                                      </label>
                                      <textarea formControlName="natureOfDefect"
                                        class="form-control warranty-invoice-textarea"
                                      maxlength="250" spellcheck="false"></textarea>
                                      <app-error-message
                                      [control]="getPartInfoControl(i,'natureOfDefect')"></app-error-message>
                                    </div>
                                  </div>
                                  <div
                                    class="col-xs-12 col-sm-12 col-md-12 col-lg-6 processing-textBlock">
                                    <div class="content">
                                      <div class="mb-3">
                                        <strong>{{'common.text_warranty_note'|cxTranslate}}</strong>
                                      </div>
                                      <p class="mb-3">
                                        {{'common.text_return_request_please_upload_all'|cxTranslate}}
                                      </p>
                                      <p class="mb-3">
                                        {{'common.text_return_request_document_attachement_all'|cxTranslate}}
                                      </p>
                                    </div>
                                    <div class="row">
                                      <div class="col-xs-12 col-sm-12 col-md-12">
                                        <div class="warranty-file-attach">
                                          <button type="button"
                                            [disabled]="isUploadAble[i] || submittedSuccessFully?.claimNumber"
                                            (click)="uploadFile(i)"
                                            class="btn btn-block blue-btn attachfile f-s w-100">
                                            {{ 'common.text_warranty_view_add_information' |
                                            cxTranslate }}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                    <p class="col-xs-12 col-sm-12 col-md-12 px-0">{{
                                    'common.text_warranty_view_max_mb' | cxTranslate }}</p>
                                    <div class="row">
                                      <div class="col-xs-12 col-sm-12 col-md-12">
                                        @if (fileList$ | async; as fileList) {
                                          <p class="file-count">
                                            (
                                            @if (fileList[i] > 0) {
                                              <span id="upload-fileList-result-number"
                                                >
                                                {{ fileList[i] || 0}}
                                              </span>
                                            } @else {
                                              0
                                            }
                                            {{ 'common.text_warranty_attachement_available'
                                            |cxTranslate }}
                                            )
                                          </p>
                                        }
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </mat-expansion-panel>
                          </mat-accordion>
                        </ng-container>
                      }
                    </ng-container>
                    <div class="add-part-number-box">
                      <div class="row">
                        <div class="col-xs-12 col-sm-12 warranty-additional-box">
                          <div class="content">
                            <cx-page-slot position="BottomContent"></cx-page-slot>
                          </div>
                          <div class="row">
                            <div class="col-xs-12 col-sm-12">
                              <button type="button" class="btn blue-btn add-part-no-btn"
                                (click)="addPartNumber()" [disabled]="submittedSuccessFully?.claimNumber">
                                {{ 'common.text_warranty_submit_part_add' | cxTranslate }}
                              </button>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-12 col-sm-12 submit-buttons">
                              <button type="button" class="btn final-review yellow-btn final-review-btn"
                                (click)="submitReviewWarrantyClaim()"
                                [disabled]="submittedSuccessFully?.claimNumber">
                                {{ 'common.checkout_summary_reviewYourOrder' | cxTranslate }}
                              </button>
                              <button class="btn yellow-btn warranty-submit" type="submit"
                                [disabled]="!isReviewed || submittedSuccessFully?.claimNumber"
                                (click)="submitWarrantyClaim()">
                                {{ 'common.text_warranty_submit_button' | cxTranslate }}
                                <img src="/icons/link-white.svg" alt="Link Icon">
                              </button>
                            </div>
                          </div>
                          @if (submittedSuccessFully?.warrantyPdf) {
                            <div class="row">
                              <div class="col-xs-12 col-sm-12 text-center">
                                <a class="btn yellow-btn warranty-print-btn" target="_blank" download
                                  [href]="baseUrl + submittedSuccessFully?.warrantyPdf.url">
                                  {{ 'common.text_warranty_print' | cxTranslate }}
                                </a>
                              </div>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </form>
            </div>
          </div>
        </div>